module.exports = __webpack_public_path__ + "static/media/aiDesignerHsbcTemplate2.d0e7aeb4.jpg";